<template>
  <div id="section2" class=" mb-5">
    <div class="tab-content ">
      <SectionTitle
        class="my-3"
        :has-line="true"
        :title="
          'Descripción del funcionamiento educativo del estudiante y todas las estrategias provistas para lograr el acceso y progreso en la corriente regular'
        "
      />
      <div>
        <label>Descripción:</label>

        <CustomTextArea
          v-show="true"
          :id="'studentEducationalFunctioningDesc'"
          v-model="model.studentEducationalFunctioningDesc"
          style="width:100%"
          :maxlength="3000"
          :classes="['eq-field', 'text-right']"
          :rows="5"
          :custom-error-msg="'Favor escriba una descripción.'"
          disabled
        />
      </div>
      <div class="tab-content my-3">
        <ReasonableAccommodationProvided
          :area-list="areaList"
          :model="model"
          is-read-only
          :is-background-gray="true"
          :arrangement="arrangement"
          @onSaveArrangement="saveArrangementList"
          @onRemoveArrangement="removeFromArrangementList"
          @onItemSelectedArrangement="selectArrangement"
          @fetchArrangement="fetchSelectedArrangementList"
        />
      </div>
    </div>
    <div class="tab-content my-3">
      <SectionTitle
        class="mt-3"
        :has-line="true"
        title="Rezagos en el idioma español y problemas conductuales"
      />

      <div class="card-pei-section2-1 ">
        <div>
          <div class="accordion-header-container">
            <div class="position-relative">
              <question
                :value="viewmodel.showRezagoIdiomaEspannol"
                description="¿Tiene el estudiante rezagos en el idioma español?"
                :answer-control-type="1"
                :option-list-value="[
                  { Value: true, Display: 'Sí' },
                  { Value: false, Display: 'No' },
                ]"
                display-number="1"
                is-disabled
                @input="viewmodel.showRezagoIdiomaEspannol = $event"
              />
            </div>
          </div>
        </div>
        <template v-if="viewmodel.showRezagoIdiomaEspannol">
          <div
            v-for="(question, index) in sectionOneQuestions"
            :key="question.number"
            class="mt-3 position-relative"
          >
            <question
              id="qsectionOneQuestions"
              :ref="'question_' + question.number"
              v-model="localSectionsQuestions[0][index].AId"
              :default-option-value-selected="question.answerId"
              :number="question.number"
              :sub-number="question.subNumber"
              :description="question.description"
              :answer-control-type="question.answerControlType"
              :error-message="question.errorMessage"
              :warning-message="question.warningMessage"
              :get-default-value="question.getDefaultValue"
              :get-options="question.getOptions"
              :option-list-value="question.optionListValue"
              :is-required="question.isRequired"
              :require-error-message="question.requireErrorMessage"
              :visible="question.isVisible"
              :display-number="`1.${index + 1}`"
              :picker-min-date="question.pickerMinDate"
              :notes="question.notes"
              :field-caption="question.fieldCaption"
              :show-field-caption="question.showFieldCaption"
              is-disabled
              @input="setQuestion($event, question)"
            />
          </div>
        </template>
      </div>
    </div>
    <div class="card-pei-section2-2 mt-5">
      <div>
        <div class="accordion-header-container">
          <div class="position-relative">
            <question
              :value="viewmodel.showProblemasConductuales"
              description="¿Presenta el estudiante problemas conductuales?"
              :answer-control-type="1"
              :option-list-value="[
                { Value: true, Display: 'Sí' },
                { Value: false, Display: 'No' },
              ]"
              display-number="2"
              is-disabled
              @input="viewmodel.showProblemasConductuales = $event"
            />
          </div>
        </div>
      </div>
      <template v-if="viewmodel.showProblemasConductuales">
        <div
          v-for="(question, index) in sectionTwoQuestions"
          :key="question.number"
          class="mt-3 position-relative"
        >
          <question
            id="qsectionTwoQuestions"
            :ref="'question_' + question.number"
            v-model="localSectionsQuestions[1][index].AId"
            :default-option-value-selected="question.answerId"
            :number="question.number"
            :sub-number="question.subNumber"
            :description="question.description"
            :answer-control-type="question.answerControlType"
            :error-message="question.errorMessage"
            :warning-message="question.warningMessage"
            :get-default-value="question.getDefaultValue"
            :get-options="question.getOptions"
            :option-list-value="question.optionListValue"
            :is-required="question.isRequired"
            :require-error-message="question.requireErrorMessage"
            :visible="question.isVisible"
            :display-number="`2.${index + 1}`"
            :picker-min-date="question.pickerMinDate"
            :notes="question.notes"
            :field-caption="question.fieldCaption"
            :show-field-caption="question.showFieldCaption"
            is-disabled
            @input="setQuestion($event, question)"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<style scoped src="@/assets/css/pei/parte-k.css"></style>

<script>
import SectionTitle from 'SectionTitle';
import Question from '@/components/pei/WizardQuestion';
import { ReasonableAccommodationProvided } from '@/components/pei/ubication-tech-assistance/_components';
import CustomTextArea from '@/components/common/CustomTextArea';
import { UTA_MANAGEMENT_SECTION_ENUM } from '@/components/pei/ubication-tech-assistance/_config/management';

export default {
  name: 'UbicationTechAssistanceSection2',
  data() {
    return {
      enums: { sections: UTA_MANAGEMENT_SECTION_ENUM },
      areaList: [],
      arrangement: {
        isModified: false,
        items: [],
        selected: [],
        temporary: [],
        grouped: [],
        placementFlag: '1',
      },
      sectionOneQuestions: [],
      sectionTwoQuestions: [],
      localSectionsQuestions: [],
      viewmodel: {
        showRezagoIdiomaEspannol: null,
        showProblemasConductuales: null,
      },
    };
  },
  components: {
    SectionTitle,
    Question,
    CustomTextArea,
    ReasonableAccommodationProvided,
  },
  props: {
    isReadOnly: {
      type: Boolean,
      default: false,
    },
    model: {
      type: Object,
      default: () => {},
    },
    techAssistanceQuestions: {
      type: Array,
      default: () => null,
    },
  },
  methods: {
    getQuestionBySection(section) {
      let self = this;
      let questionlist = [];

      section.questions.forEach(function(question) {
        let questionFields = [];
        let optionsRadios = self.getOption(question.answers);
        let answer = self.model.sectionsQuestions.find(
          (q) => q.questionId == question.id
        );

        let qt = {
          answerId: answer?.answerId,
          questionId: question.id,
          displayNumber: question.numberLabel,
          number: parseFloat(section.id + '.' + question.id),
          description: question.text,
          optionListValue: optionsRadios,
          answerControlType: 8,
          isRequired: true,
          requireErrorCode: '',
          requireErrorMessage: 'El campo es requerido.',
          initialState: true,
          fieldCaption: '',
          showFieldCaption: true,
          fields: questionFields,
          notes:
            question.toolTipText != null && question.toolTipText != undefined
              ? self.getNoteFromArrayMessege(question.toolTipText.split('|'))
              : null,
        };
        questionlist.push(qt);
      });
      return questionlist;
    },
    setQuestion(event, question) {
      let newselection = {
        QuestionId: question.questionId,
        AnswerId: event,
      };
      if (newselection.QuestionId === newselection.AnswerId) return;
      let foundquestion = this.model.sectionsQuestions.findIndex(
        (x) => x.QuestionId === newselection.QuestionId
      );

      if (foundquestion >= 0) {
        this.model.sectionsQuestions[foundquestion] = newselection;
      } else {
        this.model.sectionsQuestions.push(newselection);
      }
    },
    async loadQuestions() {
      let result = this.techAssistanceQuestions 
        ? { data: this.techAssistanceQuestions } 
        : await this.$ApiGet('/api/questionnaire/questions?questionnaireType=13');

      this.sectionOneQuestions = this.getQuestionBySection(result.data[0]);
      this.viewmodel.showRezagoIdiomaEspannol = this.sectionOneQuestions.some(
        (x) => x.answerId
      );

      this.sectionTwoQuestions = this.getQuestionBySection(result.data[1]);
      this.viewmodel.showProblemasConductuales = this.sectionTwoQuestions.some(
        (x) => x.answerId
      );

      // Validation purposes (to mitigate poor component design).
      const sectionQuestions = result?.data
        ?.slice(0, 2)
        ?.map(({ questions }) =>
          questions.map(({ id }) => ({ QId: id, AId: null }))
        );
      this.localSectionsQuestions = sectionQuestions;
    },
    getOption(options) {
      let listOptions = [];
      options.forEach(function(question) {
        listOptions.push({
          Display: question.text,
          Value: question.id,
        });
      });
      return listOptions;
    },
    getNoteFromArrayMessege(listMessege) {
      let listMsg = [];
      listMessege.forEach((msg) => {
        listMsg.push({ message: msg });
      });
      return listMsg;
    },
    fetchAreaList() {
      let self = this;
      self
        .$ApiGet('api/code/getarrangmentarea')
        .then((response) => {
          self.areaList = response.data;
        })
        .catch((errm) => {
          self.ShowToast(errm.message, '', 'error');
        });
    },
    fetchSelectedArrangementList() {
      this.$emit('fetchArrangement');
    },
    selectArrangement(item) {
      this.arrangement.temporary.map((s) => {
        if (s.id === item.id) {
          s.highlight = true;
        }
      });
    },
    saveArrangementList() {
      let self = this;
      let ids = self.arrangement.temporary
        .filter((i) => !self.arrangement.selected.find((e) => e.id === i.id))
        .map((i) => i.id);

      this.$emit('onSaveArrangement', ids);

      self.arrangement.isModified = false;
      self.arrangement.selected = this.arrangement.temporary.map((obj) => ({
        ...obj,
      }));
      self.fetchSelectedArrangementList();
    },
    removeFromArrangementList(item) {
      this.$emit('onRemoveArrangement', item);
    },
  },
  computed: {
    IsDraft: function() {
      return true;
    },
  },
  watch: {
    'viewmodel.showRezagoIdiomaEspannol'(value) {
      if (!this.isReadOnly && !value) {
        this.sectionOneQuestions = this.sectionOneQuestions.map((x) => ({
          ...x,
          answerId: null,
        }));
        this.localSectionsQuestions[0] = this.localSectionsQuestions[0].map(
          (x) => ({ ...x, AId: null })
        );
      }
    },
    'viewmodel.showProblemasConductuales'(value) {
      if (!this.isReadOnly && !value) {
        this.sectionTwoQuestions = this.sectionTwoQuestions.map((x) => ({
          ...x,
          answerId: null,
        }));
        this.localSectionsQuestions[1] = this.localSectionsQuestions[1].map(
          (x) => ({ ...x, AId: null })
        );
      }
    },
  },
  async mounted() {
    await this.loadQuestions();
    this.fetchAreaList();
    this.fetchSelectedArrangementList();
  },
};
</script>

<style scoped>
/* #section2 {
  font: normal normal normal 16px/19px Lato;
} */

#section2 >>> .bg {
  background: #f7f7f7;
}

#section2 >>> .div-error {
  background: #feeaea;
  padding: 20px;
}

#section2 >>> .div-error p {
  color: #c9545e;
  font: normal normal normal 16px/19px Lato;
  border-radius: 0px 0px 5px 5px;
}
#section2 >>> .question {
  align-content: space-between;
}

#section2 >>> .item-pane {
  justify-content: space-between;
  min-width: 50%;
  margin-top: 10px;
  display: flex;
  border-bottom: solid 1px #e2e2e2;
  box-shadow: none !important;
}

#section2 >>> .question-box {
  width: 65px;
  height: 72px;
  background: #ff7058 0% 0% no-repeat padding-box;
  border-radius: 5px 5px 0px 0px;
  text-align: center;
  color: #ffffff;
  letter-spacing: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
#section2 >>> .orange {
  color: #ff7058;
}
#section2 >>> .box-number {
  font: Bold 32px/19px Lato;
}
#section2 >>> .question-box-content.pl-55 {
  padding-left: 55px !important;
}
#section2 >>> .question-box-content p {
  padding-bottom: 0px;
}
#section2 >>> .custom-radio-container {
  padding-top: 0px !important;
  margin-right: 0px;
  height: 100%;
}
#section2 >>> .custom-radio-container > span:first-of-type {
  height: 100% !important;
}
#section2 >>> .step-label {
  text-align: center;
  font: normal normal normal 15px Lato;
  letter-spacing: 0px;
  opacity: 1;
}
#section2 >>> .radio-button-container {
  height: 100%;
  align-items: unset !important;
}
#section2 >>> .question-box-content p >>> p {
  margin-bottom: 0px !important;
}
#section2 >>> .custom-radio-button {
  margin-right: 0;
  margin-left: 8px;
}
#section2 >>> .question-box-content.pl-55 {
  padding-left: 55px !important;
}

#section2 >>> .question-box-content p {
  padding-bottom: 0px;
}

#section2 >>> .question-box-content p > p {
  margin-bottom: 0px !important;
}

#section2 >>> .header {
  font: Bold 16px/22px Lato;
  letter-spacing: 0;
  color: #ffffff;
  opacity: 1;
  background: #3f5b60 0% 0% no-repeat padding-box;
  border-radius: 5px 5px 0px 0px;
  opacity: 1;
}

#section2 >>> .row-checkbox {
  width: 20px;
  height: 20px;
  width: 10%;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #e2e2e2;
  border-radius: 4px;
  opacity: 1;
}

#section2 >>> .row-text {
  width: 90%;
}

.row-odd {
  background-color: #fafbfa;
}

#section2 >>> .row-even {
  background-color: #ffffff;
}

#section2 >>> .text-fix {
  font-weight: 400;
}

#section2 >>> .relative-top-10 {
  position: relative;
  top: 0.8em;
}

#section2 >>> .divpanelacomodos {
  border-radius: 4px;
}

#section2 >>> .question-line {
  text-align: left;
  font: normal normal normal 16px/19px Lato;
  letter-spacing: 0px;
  color: #11291b;
  opacity: 1;
}

#section2 >>> .alert span {
  text-align: left;
  font: Regular 16px/24px Lato;
  letter-spacing: 0;
  color: #f8b539;
}
.question-error {
  position: absolute;
  bottom: 0;
  left: 97px;
}
</style>
